<template>
    <div class="user-info-content">
        <a-tabs v-model:activeKey="activeKey" :animated="false">
            <a-tab-pane key="1" tab="已报名考试">
                <a-table :data-source="applyedList" :pagination="false" :bordered="true">
                    <a-table-column :key="examName" data-index="examName" title="考试场次" align="center"></a-table-column>
                    <a-table-column :key="subjectName" data-index="subjectName" title="考试科目" align="center"></a-table-column>
                    <a-table-column :key="examBeginTime" data-index="examBeginTime" title="考试时间" align="center">
                        <template v-slot="scope">
                            <span>
                                {{scope.record.examBeginTime?scope.record.examBeginTime.substr(0,10):''}}
                            </span>
                        </template>
                    </a-table-column>
                    <a-table-column :key="examAddress" data-index="examAddress" title="考试地址" align="center"></a-table-column>
                    <a-table-column :key="examResult" data-index="examResult" title="状态" align="center"></a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="2" tab="考试成绩" force-render>
                <a-table :data-source="examResultList" :pagination="false" :bordered="true">
                    <a-table-column :key="subjectName" data-index="subjectName" title="考试科目" align="center"></a-table-column>
                    <a-table-column :key="score" data-index="score" title="考试成绩" align="center"></a-table-column>
                    <a-table-column :key="certificateNumber" data-index="certificateNumber" title="证书编号" align="center"></a-table-column>
                    <a-table-column :key="endTime" data-index="endTime" title="证书过期时间" align="center">
                        <template v-slot="scope">
                            <span>
                                {{scope.record.endTime?scope.record.endTime.substr(0,10):''}}
                            </span>
                        </template>
                    </a-table-column>
                    <a-table-column :key="statusName" data-index="statusName" title="证书状态" align="center" :width="100"></a-table-column>
                    <a-table-column key="action" title="操作" align="center" :width="120">
                        <template v-slot="scope" >
              <span>
                  <a href.prevent="" v-if="scope.text.status==1" @click="downLoadCert(scope.text.certificateNumber)"> 下载证书 </a>
              </span>
            </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { downLoadExamResult,listMe } from "@/request/certificate";
import { message } from 'ant-design-vue';
const data1 = [
    {
        number: 'John Brown公司',
        subject:'桌面管理员',
        time: '2021-5-5',
        address: '上海',
        status:'待考试'
    },
    {
        number: 'Jim Green',
        subject:'桌面管理员',
        time: '2021-5-5',
        address: '山东',
        status:'待考试'
    },
    {
        number: 'Joe Black',
        subject:'系统管理员',
        time: '2021-5-5',
        address: '北京',
        status:'已完成'
    },
]
const data2= [
    {
        subject:'桌面管理员',
        score: '90',
        number: '1111111',
        timeout: '2023-5-5',
        status: 0,
    },
    {
        subject:'系统工程师',
        score: '90',
        number: '1111111',
        timeout: '2023-5-5',
        status: 0,
    },
    {
        subject:'研发工程师',
        score: '100',
        number: '1111111',
        timeout: '2023-5-5',
        status: 0,
    },
]
const token = localStorage.getItem("token")? JSON.parse(localStorage.getItem("token")): "";
export default {
  name: '',
  props: {},
  setup(){
      activeKey:ref('1')
      return {data1,data2};
  },
  data() {
    return {
        applyedList:[]
    };
  },
  mounted(){
      let token = localStorage.getItem("token")? JSON.parse(localStorage.getItem("token")): "";
    let userinfo = localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")):null
    if(userinfo && userinfo.cardNumber){
      this.SearchExamResult()
    }
    this.listMe(token)
  },
  computed: {
      ...mapGetters({
        userinfo: "user/userinfo",
        examResultList:"certificate/examResultList",
        certificateNumber:"certificate/certificateNumber",
      })
  },
  watch: {},
  methods: {
      ...mapActions({
      SearchExamResult:"certificate/SearchExamResult"
    }),
    async listMe(){
        let res = await listMe(token)
            if (res) {
                if(res.data.code == 0)
                // console.log('listme',res)
                this.applyedList = res.data.page.list
                else{
                    message.error(res.data.msg)
                }
            }
    },
    async downLoadCert(data){
      const res = await downLoadExamResult(data,token)
      const url = window.URL.createObjectURL(res.data)
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', `${data}.pdf`)
      document.body.appendChild(link)
      link.click()
    },
  },
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
::v-deep(.ant-table-bordered .ant-table-tbody > tr > td){
    border-right: none;
}
::v-deep(.ant-table-thead > tr:first-child > th:first-child){
    border-right: none;
}
::v-deep(.user-info .ant-table-tbody :last-child){
    border-bottom: 1px solid #f0f0f0;
}
:v-deep(.ant-table-bordered .ant-table-thead > tr > th){
    border-right: none;
}
::v-deep(.ant-table-thead > tr:first-child > th:last-child){
    border-right: 1px solid #f0f0f0;
}
::v-deep(.ant-table-bordered .ant-table-thead > tr > th){
    border-right: none;
}
::v-deep(.ant-table-bordered .ant-table-tbody > tr > td:last-child){
    border-right:1px solid #f0f0f0;
}
::v-deep(.ant-tabs-nav .ant-tabs-tab){
    font-size: 18px;
}
</style>